import { Mandate } from '@/types/management-mandate';
import { create } from 'zustand'

type ManagementMandateState = {
  userManagementProfile: any;
  setUserManagementProfile: (userManagementProfile: any) => void;
  questionnaire: any;
  setQuestionnaire: (questionnaire: any) => void;
  resetManagementMandate: () => void;

  listMandate: Mandate[];
  mandateDetail: Mandate;
  setListMandate: (list: Mandate[]) => void;
  setMandateDetail: (data: Mandate) => void;
}

export const useManagementMandateStore = create<ManagementMandateState>() (
  (set, get) => ({
    userManagementProfile: {},
    setUserManagementProfile: (userManagementProfile: any) => {
      set({ userManagementProfile });
    },
    questionnaire: {},
    setQuestionnaire: (questionnaire: any) => {
      set({ questionnaire: { ...get().questionnaire, ...questionnaire } });
    },
    resetManagementMandate: () => {
      set({ questionnaire: {}, userManagementProfile: {} });
    },
    listMandate: [],
    mandateDetail: {} as Mandate,
    setListMandate: (list: Mandate[]) => set({listMandate: list}),
    setMandateDetail: (data: Mandate) => set({mandateDetail: data}),
  }),
)
